"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _order = require("@/api/order");
var _zeroorder = require("@/api/zeroorder");
var _ordershipment = require("@/api/ordershipment");
var _org = require("@/api/org");
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultOrder = {
  shipment_time: '',
  courier_company: '',
  shipment_no: ''
};
var _default = exports.default = {
  data: function data() {
    return {
      listLoading: true,
      tableData: [],
      order: defaultOrder,
      order1: {},
      dialogVisible: false,
      approvalDialog: false,
      viewDialog: false,
      shipmentDialog: false,
      dialogType: 'new',
      number: '',
      rule1: {
        shipment_time: [{
          required: true,
          message: '请选择发货时间',
          trigger: 'change'
        }],
        courier_company: [{
          required: true,
          message: '请输入快递公司',
          trigger: 'blur'
        }],
        shipment_no: [{
          required: true,
          message: '请输入发货单号',
          trigger: 'blur'
        }]
      },
      statusOptions: [{
        value: 1,
        label: '通过'
      }, {
        value: 2,
        label: '拒绝'
      }],
      listQuery: {
        page: 1,
        page_size: 10
      },
      orgList: [],
      columnList: ['商品名称', '商品数量'],
      quantity: null,
      appointment_medical_no: '',
      appointment_medical_name: '',
      appointment_medical_addr: '',
      appointment_medical_contact: '',
      appointment_medical_phone: ''
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      this.listQuery.page_size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
      this.listQuery.page = val;
      this.getList();
    },
    checkPermission: _permission.default,
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _ordershipment.getNonZeroOrderList)(this.listQuery).then(function (response) {
        if (response.data) {
          // console.log(response.data)
          _this.tableData = response.data;
        }
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleShipment: function handleShipment(scope) {
      var _this2 = this;
      this.quantity = 0;
      this.order1 = Object.assign({}, scope.row); // copy obj
      this.order = Object.assign({}, defaultOrder);
      for (var i = 0; i < this.order1.planothers.length; i++) {
        this.quantity = this.quantity + this.order1.planothers[i].preparation_nums * this.order1.treatmentvouchers.length;
      }
      (0, _org.getOrg)(this.order1.appointment_medical).then(function (response) {
        _this2.appointment_medical_no = response.data.dept_no;
        _this2.appointment_medical_addr = response.data.province_name + response.data.city_name + response.data.district_name + response.data.addrs;
        if (response.data.charge_name) {
          (0, _user.getUser)(response.data.charge_name).then(function (res) {
            _this2.appointment_medical_contact = res.data.name;
          });
        }
        _this2.appointment_medical_phone = response.data.charge_contact;
      });
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this2.$refs['Form'].clearValidate();
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(form) {
        var _this3 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  (0, _ordershipment.updateNonZeroOrder)(_this3.order1.id, _this3.order).then(function (response) {
                    _this3.dialogVisible = false;
                    _this3.getList();
                    _this3.$message({
                      message: '确认成功',
                      type: 'success'
                    });
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }()
  }
};